module.exports = __webpack_public_path__ + "assets/img/section-3-landing-page-left-pic.ddf7b9e2.png";